/* VPV shared media control — background-video pause/play (WCAG 2.2.2).

   Targets any .vpv-media-toggle button and pairs it with the <video> in the
   same parent element. The button is rendered hidden in markup and revealed
   here, so there is never an inert control when JS is unavailable. Honors
   prefers-reduced-motion by starting paused. Used by VPV Media + VPV Hero. */
(function () {
  function bindToggle(btn) {
    if (btn.dataset.vpvMediaBound) return;

    var video = btn.parentElement ? btn.parentElement.querySelector('video') : null;
    if (!video) return;

    btn.dataset.vpvMediaBound = '1';
    btn.hidden = false;

    function reflect() {
      var paused = video.paused;
      btn.classList.toggle('is-paused', paused);
      btn.setAttribute('aria-label', paused ? 'Play video' : 'Pause video');
    }

    // Motion-sensitive users: don't autoplay.
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      video.autoplay = false;
      video.pause();
    }

    reflect();

    btn.addEventListener('click', function () {
      if (video.paused) {
        video.play();
      } else {
        video.pause();
      }
    });

    // Keep the icon/label in sync if playback state changes elsewhere.
    video.addEventListener('play', reflect);
    video.addEventListener('pause', reflect);
  }

  function bindWithin(root) {
    (root || document).querySelectorAll('.vpv-media-toggle').forEach(bindToggle);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { bindWithin(document); });
  } else {
    bindWithin(document);
  }

  // Theme editor: (re)wire toggles in a section as it loads.
  document.addEventListener('shopify:section:load', function (e) {
    bindWithin(e.target);
  });
})();
